module.exports = __webpack_public_path__ + "static/media/sentences-pinyin-accent-nospecialchar.d1ccd39d.txt";